import { render, staticRenderFns } from "./ReinbursementDetail.vue?vue&type=template&id=003ac5ac&scoped=true"
import script from "./ReinbursementDetail.vue?vue&type=script&lang=js"
export * from "./ReinbursementDetail.vue?vue&type=script&lang=js"
import style0 from "./ReinbursementDetail.vue?vue&type=style&index=0&id=003ac5ac&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003ac5ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('003ac5ac')) {
      api.createRecord('003ac5ac', component.options)
    } else {
      api.reload('003ac5ac', component.options)
    }
    module.hot.accept("./ReinbursementDetail.vue?vue&type=template&id=003ac5ac&scoped=true", function () {
      api.rerender('003ac5ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/reinbursement/ReinbursementDetail.vue"
export default component.exports